import { styled } from "styled-components";
import { CirclebtnProps } from "../common/types";
import Image from "../common/CircularImgProps";
import React, { useRef } from "react";
import { useRippleEffect } from "../../hooks/useRippleEffect";
import GsapMagnetic from "./GsapMagnetic";

export const Circlebtn = styled.button<CirclebtnProps>` 
  background: ${({ theme, $bgColor }) =>
    $bgColor || theme.circularIconBg};
  color: ${({ theme, $color }) => $color || theme.circularIconTextBg};
  font-weight: ${({ $fontWeight }) => $fontWeight || "light"};
  width: ${({ $size, $width }) => $size || $width || "140px"};
  height: ${({ $size, $height }) => $size || $height || "140px"};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${({ $margin }) => $margin || "0"};
  border: none;
  position: ${({ $position }) => $position || "static"};
  top: ${({ $top }) => $top || "auto"};
  right: ${({ $right }) => $right || "auto"};
  z-index: ${({ $zindex }) => ($zindex !== undefined ? $zindex : "auto")};
  overflow: hidden;
  &:active {
    background-color: ${({ theme, $bgColor }) =>
      $bgColor || theme.circularIconBg};
  }
  white-space: pre; /* Ensure that white-space is preserved */
  
  //works when ripple is added
  .ripple {
    position: absolute;
    border-radius: 50%;
    background: ${({ theme }) => theme.ripplebg};
    pointer-events: none;
    transform: scale(0);
    animation: ripple 0.7s ease-out;
  }
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  
  transition: ${({$transition}) => $transition || 'none' }


`;

function CircleBtn({children, ...props }: CirclebtnProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  //ripple effect
  useRippleEffect(buttonRef);

  if (props.$imageUrl && !props.$text) {
    console.warn("You should provide 'text' prop as alt text for the image.");
  }

  return (
    <>
      <GsapMagnetic
        $magneticBorderRadius={props.$magneticBorderRadius}
        $magneticMargin={props.$magneticMargin}
        $magneticBorder={props.$magneticBorder}
        $magneticPosition={props.$magneticPosition}
        $magneticTop={props.$magneticTop}
        $magneticRight={props.$magneticRight}
        $magneticZindex={props.$magneticZindex}
        $maxTranslation={props.$maxTranslation}
      >
        <Circlebtn {...props} ref={buttonRef} >
          {
          children ? (
            children
          ):
          props.$imageUrl ? (
            <Image
              src={props.$imageUrl}
              alt={props.$text || "Icon"}
              $imgSize={props.$imgSize}
              $imgWidth={props.$imgWidth}
              $imgHeight={props.$imgHeight}

              className="imgPresent"
            />
          ) : (
            <span className="txtPresent">{props.$text}</span>
          )}
        </Circlebtn>
      </GsapMagnetic>
    </>
  );
}

export default React.memo(CircleBtn);
